import { faGithub, faLinkedin, faYoutube, faUpwork, faTelegram, faFacebook, faTwitter, faInstagram, faMedium, faBehance, faDribbble, faStackOverflow, faAngellist, faQuora, faVimeo, faSoundcloud } from '@fortawesome/free-brands-svg-icons';
import { faLink } from '@fortawesome/free-solid-svg-icons';

const linkIcons = {
    github: faGithub,
    linkedin: faLinkedin,
    youtube: faYoutube,
    upwork: faUpwork,
    telegram: faTelegram,
    facebook: faFacebook,
    website: faLink,
    portfolio: faLink,
    twitter: faTwitter,
    instagram: faInstagram,
    medium: faMedium,
    behance: faBehance,
    dribbble: faDribbble,
    stackoverflow: faStackOverflow,
    angellist: faAngellist,
    blog: faLink,
    researchgate: faLink,
    devto: faLink,
    quora: faQuora,
    vimeo: faVimeo,
    soundcloud: faSoundcloud
};

const linkText = {
    github: 'GitHub',
    linkedin: 'LinkedIn',
    youtube: 'YouTube',
    upwork: 'Upwork',
    telegram: 'Telegram',
    facebook: 'Facebook',
    website: 'Website',
    portfolio: 'Portfolio',
    twitter: 'Twitter',
    instagram: 'Instagram',
    medium: 'Medium',
    behance: 'Behance',
    dribbble: 'Dribbble',
    stackoverflow: 'Stack Overflow',
    angellist: 'AngelList',
    blog: 'Blog',
    researchgate: 'ResearchGate',
    devto: 'Dev.to',
    quora: 'Quora',
    vimeo: 'Vimeo',
    soundcloud: 'SoundCloud'
};

const normalizeKey = (key) => key.toLowerCase().replace(/\s+/g, '');

const normalizedLinkIcons = {};
const normalizedLinkText = {};

Object.keys(linkIcons).forEach(key => {
    normalizedLinkIcons[normalizeKey(key)] = linkIcons[key];
});

Object.keys(linkText).forEach(key => {
    normalizedLinkText[normalizeKey(key)] = linkText[key];
});

export { normalizedLinkIcons as linkIcons, normalizedLinkText as linkText };
